import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  const inputCls =
    "w-full rounded-lg bg-obsidian border border-white/10 px-4 py-3 text-ink placeholder:text-ink-muted focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/40 transition-colors";

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-6 relative z-10">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink-muted hover:text-amber transition-colors mb-8">
          <ArrowLeft size={15} /> Back to site
        </Link>
        <div className="rounded-2xl border border-white/[0.07] bg-surface p-8 md:p-10">
          <div className="font-display text-lg font-bold tracking-[0.06em] mb-1">
            AMIRAN <span className="text-amber">AZALADZE</span>
          </div>
          <h1 className="font-display text-3xl font-medium mb-2">Admin Login</h1>
          <p className="text-ink-secondary text-sm mb-8">Manage blog posts and view inquiries.</p>

          <form data-testid="login-form" onSubmit={submit} className="space-y-5">
            <div>
              <label className="block text-sm text-ink-secondary mb-2">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@azaladze.ge" className={inputCls} />
            </div>
            <div>
              <label className="block text-sm text-ink-secondary mb-2">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-red-400 bg-red-400/10 border border-red-400/20 rounded-lg px-4 py-3">
                {error}
              </div>
            )}
            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="group w-full inline-flex items-center justify-center gap-2 rounded-lg bg-amber px-6 py-3.5 font-semibold text-obsidian hover:bg-amber-hover transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Sign In"}
              {!loading && <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
